import { reactive,getCurrentInstance } from 'vue'
import baseService from './axios'
import { baseURL } from '@/utils/util'
import { message  } from 'ant-design-vue'

export type HttpMethod=(url:string,data: any) => Promise<Result>
export interface Result {
  state: nubmer;
  message: string;
  data: any;
}

export const http={
 async get(url:string,data:object){
    var _url=baseURL+url
    var res=await baseService.get(_url,{params:data})
      if(res.state!=1){
          console.warn('HTTP错误',_url,res.message)
      }
      return res
  },
 async post(url:string,data:object){
    var _url=baseURL+url
    var res=await baseService.post(_url,data)
      if(res.state!=1){
          console.warn('HTTP错误',_url,res.message)
      }
      return res
  }
}

/*
export const api=
  {
      user:{
        login:(data:object)=>{
           return http.get("/Login/CheckLogin",data)
        },
        yzm:(data:object)=>{
          return http.get("/APP/sendLoginYZM",data)
        }
      },
      menu:{
        list: async function (data) {
          return http.get("/Menu/GetTree",data)
        },
        add: async function (data) {
          return http.get("/Menu/SubMit",data)
        },
        get: async function (data) {
          return http.get('/Menu/GetById', data)
        },
        del: async function (data) {
          return http.get('/Menu/Del', data)
        }
      },
      role : {
        list: async function (params) {
          return http.get('/Role/GetList', params)
        },
        add: async function (params) {
          return http.post('/Role/SubMit', params)
        },
        get: async function (params) {
          return http.get('/Role/GetById', params)
        },
        del: async function (params) {
          return http.get('/Role/Del', params)
        },
        authsetlist: async function (params) {
          return http.get('/Role/getAuthSetList', params)
        },
        subAuthRole: async function (params) {
          return http.post('/Role/updateRoleItem', params)
        }
      }
  }
*/

const menu = {
  list: async function (params) {
    return http.get('/Menu/GetTree', params)
  },
  add: async function (params) {
    return http.post('/Menu/SubMit', params)
  },
  get: async function (params) {
    return http.get('/Menu/GetById', params)
  },
  del: async function (params) {
    return http.get('/Menu/Del', params)
  }
}

const role = {
  list: async function (params) {
    return http.get('/Role/GetList', params)
  },
  add: async function (params) {
    return http.post('/Role/SubMit', params)
  },
  get: async function (params) {
    return http.get('/Role/GetById', params)
  },
  del: async function (params) {
    return http.get('/Role/Del', params)
  },
  authsetlist: async function (params) {
    return http.get('/Role/getAuthSetList', params)
  },
  subAuthRole: async function (params) {
    return http.post('/Role/updateRoleItem', params)
  }
}

const setting = {
  list: async function (params) {
    return http.get('/Setting/GetList', params)
  },
  add: async function (params) {
    return http.post('/Setting/SubMit', params)
  },
}

const words = {
  list: async function (params) {
    return http.get('/Words/GetTree', params)
  },
  get: async function (params) {
    return http.get('/Words/GetById', params)
  },
  add: async function (params) {
    return http.post('/Words/SubMit', params)
  },
  del: async function (params) {
    return http.get('/Words/Del', params)
  },
  getByPid: async function (id) {
    return http.get('/Words/GetTreeById', { id: id })
  },
  getByName: async function (name) {
    return http.get('/Words/GetTreeByName', { name: name })
  },
}

const msg = {
  list: async function (params) {
    return http.get('/Message/GetUserMessage', params)
  },
  listip: async function (params) {
    return http.get('/Message/GetUserMessageTip', params)
  },
  //单个发送
  add: async function (params) {
    return http.get('/Message/SubMit', params)
  },
  //以角色发送
  groupadd: async function (params) {
    return http.get('/Message/SubmitFormGroup', params)
  },
  read: async function (id) {
    return http.get('/Message/Readed', { id: id })
  },
  del: async function (id) {
    return http.get('/Message/Del', { id: id })
  },
}

const logs = {
  list: async function (params) {
    return http.get('/Logs/GetList', params)
  },
  dels: async function (params) {
    return http.post('/Logs/Dels', params)
  }
}

const user = {
  login:(data:object)=>{
           return http.get("/Login/CheckLogin",data)
        },
  yzm:(data:object)=>{
          return http.get("/APP/sendLoginYZM",data)
  },
  self: async function () {
    return http.get('/Users/getUserSelf')
  },
  list: async function (params) {
    return http.get('/Users/GetVList', params)
  },
  enable: async function (params) {
    return http.get('/Users/setEnable', params)
  },
  get: async function (id) {
    return http.get('/Users/GetById', { id: id })
  },
  getv: async function (id) {
    return http.get('/Users/GetVById', { id: id })
  },
  reg: async function (params) {
    return http.post('/Login/Reg', params)
  },
  adduser:async (params)=>{
    return http.post('/users/AddUser', params)
  },

  change: async function (params) {
    return http.post('/users/ChangeInfo', params)
  },
  static: async function (params) {
    return http.get('/Users/getStaticInfo', params)
  },
  todo: async function (params) {
    return http.get('/Users/getTodoInfo', params)
  },
  changepassword: async function (params) {
    return http.get('/Users/ChangePW', params)
  },
  changeusertype (params) {
    //params:{userid,usertype,province,city,area}
    return http.get('/Users/changeUsertype', params)
  },
  resetpassword (id) {
    return http.get('/Users/resetPassWord', { id: id })
  }
}
const worklogs = {
  list: function (params) {
    return http.get('/Worklogs/GetList', params)
  },
  add: function (params) {
    return http.post('/Worklogs/SubMit', params)
  },
  del: function (id) {
    return http.get('/Worklogs/Del', { id: id })
  },
}

const report = {
  todo(){
    return http.get('/Report/getTodo')
  },
  get (params) {
    return http.get('/Admin/GetReport', params)
  }
}
const sitepage = {
  list (params) {
    return http.get('/SitePage/GetList', params)
  },
  del (id) {
    return http.get('/SitePage/Del', { id: id })
  },
  dels(ids){//ids:[]
    return http.post('/SitePage/Dels', ids)
  },
  add (params) {
    return http.post('/SitePage/SubMit', params)
  },
  itemlist(id){
    return http.get('/SitePage/getItemsByID', { id: id })
  },
  submititem(params){
    //params={list:[],pageID:}
    return http.post('/SitePage/addItem', params)
  },
  delitem(pageID,sectionID,flag){
    return http.get('/SitePage/delItem', { pageID: pageID,sectionID:sectionID,flag:flag })
  },
  styles(params){
    return http.get('/Style/GetList', params)
  },
  sections(params){
    return http.get('/Section/getTreeList', params)
  },
  defsections(params){
    return http.get('/Section/getStaticList', params)
  },
  page(params){
    //params｛id:必需的这里是page的ID｝
    return http.get('/Home/getPageSections', params)
  },
  pagesection(params){
    //params｛pageID:,sectionID,flag｝
    return http.get('/Home/getPageSection', params)
  }
}
const source = {
  list (params) {
    return http.get('/Source/GetList', params)
  },
  listree (params) {
    return http.get('/Source/GetListTree', params)
  },
  add (params) {
    return http.post('/Source/SubMit', params)
  },
  adds (params) {
    return http.post('/Source/SubMits', params)
  },
  del (id) {
    return http.get('/Source/Del', { id: id })
  },
  search (keyword) {
    return http.get('/Source/Search', { keyword: keyword, pageFlag: false })
  }
}
const workgroup = {
  list () {
    return http.get('/Workgroup/GetList', { pageFlag: false })
  },
  del (id) {
    return http.get('/Workgroup/Del', { id: id })
  },
  add (params) {
    return http.post('/Workgroup/SubMit', params)
  },
  userlist (id) {
    return http.get('/Workgroup/getUsers', { pageFlag: false, id: id })
  },
  deluser (id,userid) {
    return http.get('/Workgroup/exit', { id: id,uid:userid })
  },
  adduser (id,userids) {
    return http.get('/Workgroup/addUser', {id:id,uid:userids})
  }
}

const ailist = {
  list () {
    return http.get('/Ai/GetList', { pageFlag: false })
  },

  airesult (params) {
    return http.post('/Ai/AiResult', params)
  }
}
const product={
  list(params){
    return http.get('/Product/GetList', params)
  },
  get(id){
    return http.get('/Product/getProductInfo', { id: id })
  },
  del(id){
    return http.get('/Product/Del', { id: id })
  },
  dels(ids){
    return http.post('/Product/Dels', ids)
  },
  onoff(id){
    return http.get('/Product/onoff', { id: id })
  },
  add(params){
     return http.post('/Product/SubMits', params)
  }
}
const protype={
  list(params){
    return http.get('/ProductType/GetList',params)
  },
  dels(ids){
     return http.post('/ProductType/Dels', ids)
  },
  add(params){
    return http.post('/ProductType/SubMit', params)
  }
}
const global={
  header(){
     return http.get('/Home/getMainMenu')
  },
  footer(){
     return http.get('/Home/getFootMenu')
  },
  siteinfo(){
    return http.get('/Home/getSiteInfo')
  },
  citys(){
     return http.get('/APP/getCitys')
  },
  citychild(id){
     return http.get('/APP/getChildCitys')
  }
}
const companly={
  tree(){
     return http.get('/Companly/GetTree')
  },
  add(params){
     return http.post('/Companly/SubMit',params)
  },
  del(id){
    return http.get('/Companly/Del',{id:id})
  },
  users(id){
    return http.get('/CompanlyUsers/getUsersById',{id:id})
  },
  deluser(id){
    return http.get('/CompanlyUsers/Del',{id:id})
  },
  adduser(params){
     return http.post('/CompanlyUsers/SubMit',params)
  }
}
const section={
  list(params){
     return http.get('/Section/GetList',params)
  },
  get(id){
    return http.get('/Section/GetById',{id:id})
  },
  getitems(id){
    return http.get('/Section/getTreeById',{id:id})
  },
  add(params){
     return http.post('/Section/SubMit',params)
  },
  del(id){
    return http.get('/Section/Del',{id:id})
  },
  setxy(params){
    //params=[{id:section的ID,x:,y:两者都是0.1的百分比float}]
    return http.post('/Section/SubmitLocations',params)
  },
}
const sitemenu={
  list(params){
     return http.get('/SiteMenu/GetList',params)
  },
  get(id){
    return http.get('/SiteMenu/GetById',{id:id})
  },
  del(id){
    return http.get('/SiteMenu/Del',{id:id})
  },
  add(params){
     return http.post('/SiteMenu/SubMit',params)
  },
}
const list={
  list(params){
     return http.get('/List/GetList',params)
  },
  get(id){
    return http.get('/List/GetById',{id:id})
  },
  getv(no){
    return http.get('/List/GetVById',{no:no})
  },
  status(){
    return http.get('/List/GetListStatus')
  },
  cancellist(params){
     return http.get('/List/GetCencelList',params)
  },
  cancel(no,enable,request){
     return http.get('/List/EnableCancel',{no:no,enable:enable,request:request})
  }
}
const jobs={
  list(){
     return http.get('/QuartzJob/GetList')
  },
  startjob(name,group){
    return http.get('/QuartzJob/StartJob',{name:name,group:group})
  },
  stopjob(name,group){
    return http.get('/QuartzJob/StopJob',{name:name,group:group})
  }
}


const device={
  list(params){
     return http.get('/Device/GetList',params)
  },
  get(id){
    return http.get('/Device/GetById',{id:id})
  },
  del(id){
    return http.get('/Device/Del',{id:id})
  },
  add(params){
     return http.post('/Device/SubMit',params)
  },
  model(){
    return http.get('/Device/GetModelInfo')
  },
  moniters(){
    return http.get('/Device/GetDeviceMoniters')
  },
  restart(id){
    return http.get('/Device/RestartDevice',{id:id})
  },
  devicetree(){
    return http.get('/Device/GetDeviceTree')
  }

}
const systemconf={
  get(){
    return http.get('/SystemConfig/Get')
  },
  set(params){
     return http.post('/SystemConfig/Set',params)
  },
  model(){
    return http.get('/SystemConfig/GetModelInfo')
  }
}
const deviceconf={
  list(params){
     return http.get('/DeviceConfig/GetList',params)
  },
  get(id){
    return http.get('/DeviceConfig/GetById',{id:id})
  },
  del(id){
    return http.get('/DeviceConfig/Del',{id:id})
  },
  add(params){
     return http.post('/DeviceConfig/SubMit',params)
  },
  model(){
    return http.get('/DeviceConfig/GetModelInfo')
  },

}
const devicevar={
  list(params){
     return http.get('/DeviceVariable/GetList',params)
  },
  get(id){
    return http.get('/DeviceVariable/GetById',{id:id})
  },
  del(id){
    return http.get('/DeviceVariable/Del',{id:id})
  },
  add(params){
     return http.post('/DeviceVariable/SubMit',params)
  },
  model(DeviceId){
    return http.get('/DeviceVariable/GetModelInfo',{DeviceId:DeviceId})
  },
  set(DeviceId,ids,value){
    return http.get('/DeviceVariable/SetVariable',{DeviceId:DeviceId,ids:ids,value:value})
  }
}
const driver={
  list(params){
     return http.get('/Driver/GetList',params)
  }
}
const devicegroup={
  list(params){
     return http.get('/DeviceGroup/GetList',params)
  },
  mlist(){
    return http.get('/DeviceGroup/GetMList')
  },
  get(id){
    return http.get('/DeviceGroup/GetById',{id:id})
  },
  del(id){
    return http.get('/DeviceGroup/Del',{id:id})
  },
  add(params){
     return http.post('/DeviceGroup/SubMit',params)
  },
  model(){
    return http.get('/DeviceGroup/GetModelInfo')
  }
}
const rpclog={
  list(params){
     return http.get('/RpcLog/GetList',params)
  },
  get(id){
    return http.get('/RpcLog/GetById',{id:id})
  },
  del(id){
    return http.get('/RpcLog/Del',{id:id})
  },
  add(params){
     return http.post('/RpcLog/SubMit',params)
  },
  model(){
    return http.get('/RpcLog/GetModelInfo')
  }
}
const sceneconfig={
  get(){
    return http.get('/SceneConfig/Get')
  },
  add(params){
     return http.post('/SceneConfig/SubMit',params)
  },
  model(){
    return http.get('/SceneConfig/GetModelInfo')
  }
}
const scene={
  get(){
    return http.get('/SceneConfig/Get')
  },
  add(params){
     return http.post('/SceneConfig/SubMit',params)
  },
  model(){
    return http.get('/SceneConfig/GetModelInfo')
  }
}
const deviceconfigration={
  list(){
     return http.get('/DeviceConfigration/GetList')
  },
  add(params){
     return http.post('/DeviceConfigration/SubMit',params)
  },
}
const devicealarm={
  list(){
     return http.get('/DeviceAlarm/GetList')
  },
  model(){
    return http.get('/DeviceAlarm/GetModelInfo')
  }
}
const devicescene={
  //type:0 2d|1 3d
  list(params){
     return http.get('/DeviceScene/GetList',params)
  },
  get(id){
    return http.get('/DeviceScene/GetById',{id:id})
  },
  add(params){
     return http.post('/DeviceScene/SubMit',params)
  },
  del(id){
    return http.get('/DeviceScene/Del',{id:id})
  },
  model(){
    return http.get('/DeviceScene/GetModelInfo')
  },
  save(params){
    return http.post('/DeviceScene/SaveSceneData',params)
  }
}

const scaner={
  list(params){
     return http.get('/Scaner/GetList',params)
  },
  get(id){
    return http.get('/Scaner/GetById',{id:id})
  },
  del(id){
    return http.get('/Scaner/Del',{id:id})
  },
  add(params){
     return http.post('/Scaner/SubMit',params)
  },
  model(){
    return http.get('/Scaner/GetModelInfo')
  },
  detail(id){
    return http.get('/Scaner/GetDetail',{id:id})
  },
  start(id){
    return http.get('/Scaner/StartById',{id:id})
  }
}
const camara={
  list(params){
     return http.get('/Camara/GetList',params)
  },
  get(id){
    return http.get('/Camara/GetById',{id:id})
  },
  del(id){
    return http.get('/Camara/Del',{id:id})
  },
  add(params){
     return http.post('/Camara/SubMit',params)
  },
  model(){
    return http.get('/Camara/GetModelInfo')
  },
}

const auth=():any=>{
  const { proxy }: any = getCurrentInstance()
  if(proxy.$router.currentRoute.value.meta.rule){
    return proxy.$router.currentRoute.value.meta.rule
  }else{
    var res:any={see:1,creating:1,edit:1,del:1,agent:0}
    return res
  }
}
const api= {auth,global,
  menu, role, setting, words, logs, msg, user, worklogs,
  report, sitepage,
  source,   workgroup,
  ailist,
  product,protype,
  companly,section,sitemenu,
  list,
  device,deviceconf,devicevar,devicegroup,rpclog,systemconf,driver,jobs,scene,sceneconfig,deviceconfigration,devicealarm,devicescene,
  scaner,camara
}

export default api
